import {
  PARENT_TASKS_COLUMN_HEADER,
  RELATED_REQUESTS_COLUMN_HEADER,
} from '../../../pages/employee-flow/const';
import { FeatureFlaggedColumnVisibility } from '../../models/feature-flagged-column-visibility.model';

export function isFeatureFlaggedColumnVisible(
  columnHeader: string,
  {
    showParentTasksColumn = true,
    showRelatedRequestsColumn = true,
  }: FeatureFlaggedColumnVisibility = {}
): boolean {
  if (columnHeader === PARENT_TASKS_COLUMN_HEADER) {
    return showParentTasksColumn;
  }

  if (columnHeader === RELATED_REQUESTS_COLUMN_HEADER) {
    return showRelatedRequestsColumn;
  }

  return true;
}
